/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".crop-long-text[_ngcontent-%COMP%]{min-width:0;overflow:hidden;text-overflow:ellipsis}"];
export { styles as styles };
